// eslint-disable-next-line no-restricted-imports
import { Palette } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import { TypographyVariantsOptions } from '@mui/material/styles/createTypography';

/**
 * Represents different typography variants.
 */
export type TypographyVariant =
  | 'headerBold' // h1
  | 'header' // h1
  | 'title' // h2
  | 'subtitle' // h3
  | 'headline'
  | 'body'
  | 'bodyMedium'
  | 'bodySemiBold'
  | 'bodyBold'
  | 'caption'
  | 'captionMedium'
  | 'captionBold'
  | 'captionSemiBold'
  | 'small'
  | 'smallMedium';

/** Fonts */
export enum FONTS {
  main = 'Nunito Sans',
}
/**
 * Defines typography styles based on the provided palette.
 */
export const typography: (
  palette: Palette
) => TypographyVariantsOptions = () => ({
  fontFamily: `${FONTS.main}, sans-serif`,
  headerBold: {
    fontSize: 32,
    lineHeight: '100%',
    fontWeight: 700,
  },
  header: {
    fontSize: 32,
    lineHeight: '100%',
  },
  title: {
    fontSize: 28,
    lineHeight: '100%',
    fontWeight: 700,
  },
  headline: {
    fontSize: 24,
    lineHeight: '100%',
    fontWeight: 600,
  },
  subtitle: {
    fontSize: 20,
    lineHeight: '160%',
    fontWeight: 700,
  },
  body: {
    fontSize: 16,
    lineHeight: '160%',
    fontWeight: 400,
  },
  body1: {
    fontSize: 16,
    lineHeight: '160%',
  },
  bodyMedium: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '160%',
  },
  bodySemiBold: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '160%',
  },
  bodyBold: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '160%',
  },
  caption: {
    fontSize: 14,
    lineHeight: '160%',
  },
  captionMedium: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '160%',
  },
  captionSemiBold: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '160%',
  },
  captionBold: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '160%',
  },

  small: {
    fontSize: 12,
  },
  smallMedium: {
    fontSize: 12,
    fontWeight: 500,
  },

  button: {},
  overline: {},
  subtitle2: {},
});
